module.exports = __webpack_public_path__ + "img/loadingBg.8e4988ff.jpg";